import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/layouts/navbar/navbar.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { ServicesTwoComponent } from './components/pages/services-two/services-two.component';
import { WebsiteDevelopment } from './components/pages/website-development/website-development.component';
import { PortfolioComponent } from './components/pages/portfolio-list/portfolio-list.component';
import { ChattingComponent } from './components/common/chatting/chatting.component';
import { OurClientComponent } from './components/layouts/our-client/our-client.component';
import { MobileDevelopment } from './components/pages/mobile-development/mobile-development.component';
import { ErpCmsDevelopment } from './components/pages/erp-cms/erp-cms.component';
import { CustomSoftwareDevelopment } from './components/pages/custom-software-development/custom-software-development.component';
import { DigitalMarketing } from './components/pages/digital-marketing/digital-marketing.component';
import { HostingRegistration } from './components/pages/hosting-registration/hosting-registration.component';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    PreloaderComponent,
    HomeOneComponent,
    FooterComponent,
    AboutComponent,
    ContactComponent,
    ServicesTwoComponent,
    WebsiteDevelopment,
    PortfolioComponent,
    ChattingComponent,
    MobileDevelopment,
    ErpCmsDevelopment,
    CustomSoftwareDevelopment,
    DigitalMarketing,
    HostingRegistration
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    OurClientComponent,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule, // required animations module
    NgxSpinnerModule,
    ToastrModule.forRoot(), // ToastrModule added
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
